export default "__VITE_ASSET__db5440fb__"